import type { PropertyType } from '@/interfaces'

export function isDisplayableProperty(property: PropertyType): boolean {
  return property.units.length > 0 || property.solarbot_units.length > 0
}

export function selectableProperties(
  properties: PropertyType[]
): PropertyType[] {
  const displayable = properties.filter(isDisplayableProperty)

  return displayable.length > 0 ? displayable : properties
}
